import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AccessRequest } from '@model';
import { environment } from 'environments/environment';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable({
  providedIn: 'root'
})
export class AccessRequestService {
    constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

    getMyAccessRequests(): Observable<AccessRequest[]> {
        return this.http
            .get<AccessRequest[]>(`${environment.apiEndpoint}/Account/AccessRequests`)
            .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }

    removeAccessRequest(item: AccessRequest): Observable<boolean> {
        return this.http
            .delete<boolean>(`${environment.apiEndpoint}/AccessRequests/${item.id}`, { body: item })
            .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }
}